var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512.001,
    height: 335.449,
    viewBox: "0 0 512.001 335.449",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "india",
    transform: "translate(0 -88.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1703",
    "data-name": "Path 1703",
    d: "M512,200.093H0V97.1a8.829,8.829,0,0,1,8.828-8.828H503.173A8.829,8.829,0,0,1,512,97.1V200.093Z",
    fill: "#fab446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1704",
    "data-name": "Path 1704",
    d: "M503.172,423.725H8.828A8.829,8.829,0,0,1,0,414.9V311.909H512V414.9A8.828,8.828,0,0,1,503.172,423.725Z",
    fill: "#73af00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_654",
    "data-name": "Rectangle 654",
    width: 512,
    height: 111.81,
    transform: "translate(0 200.091)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3056",
    "data-name": "Group 3056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1705",
    "data-name": "Path 1705",
    d: "M256,303.449A47.448,47.448,0,1,1,303.448,256,47.5,47.5,0,0,1,256,303.449Zm0-86.069A38.621,38.621,0,1,0,294.621,256,38.662,38.662,0,0,0,256,217.38Z",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_113",
    "data-name": "Ellipse 113",
    cx: 5.379,
    cy: 5.379,
    r: 5.379,
    transform: "translate(250.621 250.622)",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1706",
    "data-name": "Path 1706",
    d: "M256,256.808l-13.67,1.38-29.364-1.38v-1.614l29.364-1.38,13.67,1.38Z",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1707",
    "data-name": "Path 1707",
    d: "M256,256.808l13.67,1.38,29.364-1.38v-1.614l-29.364-1.38L256,255.194Z",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1708",
    "data-name": "Path 1708",
    d: "M255.193,256l-1.38-13.67,1.38-29.364h1.614l1.38,29.364L256.807,256Z",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1709",
    "data-name": "Path 1709",
    d: "M255.193,256l-1.38,13.67,1.38,29.364h1.614l1.38-29.364L256.807,256Z",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1710",
    "data-name": "Path 1710",
    d: "M255.43,256.571l-10.642-8.689L225,226.142,226.141,225l21.74,19.788,8.689,10.642Z",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1711",
    "data-name": "Path 1711",
    d: "M255.43,256.571l8.689,10.642L285.859,287,287,285.86l-19.788-21.74-10.642-8.689Z",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1712",
    "data-name": "Path 1712",
    d: "M255.43,255.431l8.689-10.642L285.859,225,287,226.142l-19.788,21.74-10.642,8.689Z",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1713",
    "data-name": "Path 1713",
    d: "M255.43,255.431l-10.642,8.689L225,285.86,226.141,287l21.74-19.788,8.689-10.642Z",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1714",
    "data-name": "Path 1714",
    d: "M256.309,256.747l-12.1,6.506-27.656,9.962-.618-1.491,26.6-12.512,13.157-3.957Z",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1715",
    "data-name": "Path 1715",
    d: "M256.309,256.747l13.157-3.957,26.6-12.512-.618-1.491-27.656,9.962-12.1,6.506Z",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1716",
    "data-name": "Path 1716",
    d: "M255.254,256.31l-6.506-12.1-9.962-27.656,1.491-.618,12.512,26.6,3.957,13.157Z",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1717",
    "data-name": "Path 1717",
    d: "M255.254,256.31l3.957,13.157,12.512,26.6,1.491-.618-9.962-27.656-6.506-12.1Z",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1718",
    "data-name": "Path 1718",
    d: "M255.691,256.747l-13.157-3.957-26.6-12.512.618-1.491,27.656,9.962,12.1,6.506Z",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1719",
    "data-name": "Path 1719",
    d: "M255.691,256.747l12.1,6.506,27.656,9.962.618-1.491-26.6-12.512-13.157-3.957Z",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1720",
    "data-name": "Path 1720",
    d: "M255.254,255.692l3.957-13.157,12.512-26.6,1.491.618-9.962,27.656-6.506,12.1Z",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1721",
    "data-name": "Path 1721",
    d: "M255.254,255.692l-6.506,12.1-9.962,27.656,1.491.618,12.512-26.6,3.957-13.157Z",
    fill: "#41479b"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    cx: 7.256,
    cy: 7.256,
    r: 7.256,
    transform: "translate(248.744 248.745)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    cx: 4.351,
    cy: 4.351,
    r: 4.351,
    transform: "translate(251.649 251.65)",
    fill: "#41479b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/india.e900a0db198e0c2f60ef2ff46cb4916f.svg";
export { ForwardRef as ReactComponent };